import Vue from 'vue'
import ElementUI, { Dialog } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 弹窗默认挂到 body，避免嵌套滚动容器内定位异常
Dialog.props.appendToBody.default = true

Vue.use(ElementUI)
